import * as React from 'react';
import { AnalyticsTrigger } from '@core-front/analytics';
import { CookieConsentContext, } from '@core-front/cookie-consent-provider';
import PropsChecker from '@core-front/props-checker';
const VideoCore = (props) => {
    return (React.createElement(PropsChecker, { componentProps: props, componentName: "Video", defaultValueName: "defaultPlaying", valueName: "playing", onChangeNames: "onPlay" },
        React.createElement(AnalyticsTrigger, { trigger: {
                callback: 'onPlay',
                id: `Video - ${props.title}`,
                elementType: 'video',
                elementId: props.title,
                interactionType: 'play',
            } },
            React.createElement(VideoCoreInner, Object.assign({}, props)))));
};
export class VideoCoreInner extends React.Component {
    constructor(props) {
        super(props);
        this.video = React.createRef();
        this.handleClick = (event) => {
            event.preventDefault();
            this.play();
        };
        this.play = () => {
            if (typeof this.props.playing === 'undefined') {
                this.setState({
                    playing: true,
                });
            }
            if (this.props.onPlay) {
                this.props.onPlay();
            }
        };
        this.pause = () => {
            if (typeof this.props.playing === 'undefined') {
                this.setState({
                    playing: false,
                });
            }
            if (this.props.onPause) {
                this.props.onPause();
            }
        };
        this.getUrl = (props) => {
            let url = props.url + '?autoplay=1';
            if (this.props.defaultPlaying) {
                url += '&muted=1';
            }
            return url;
        };
        this.state = {
            playing: props.defaultPlaying || false,
            hideOverview: props.hideOverview || false,
            isMounted: false,
        };
    }
    componentDidMount() {
        this.hideOverview();
        this.setState({
            isMounted: true,
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.isHtml5(this.props) && this.props.sources) {
            const prevPlaying = prevProps.onPlay && typeof prevProps.playing !== 'undefined' ? prevProps.playing : prevState.playing;
            if (prevPlaying !== this.playing && this.video && this.video.current) {
                if (this.playing) {
                    this.video.current.play();
                }
                else {
                    this.video.current.pause();
                }
            }
        }
        this.hideOverview();
    }
    get playing() {
        const { needsConsent } = this.props;
        // if without consent, we are not allowed to load the video
        if (!this.context.hasConsent(needsConsent)) {
            return false;
        }
        return this.props.onPlay && typeof this.props.playing !== 'undefined' ? this.props.playing : this.state.playing;
    }
    hideOverview() {
        if (!this.state.hideOverview && this.playing) {
            this.setState({
                hideOverview: true,
            });
        }
    }
    isHtml5(props) {
        return props.implementation === 'html5';
    }
    BEM(modifier) {
        const { needsConsent, position, className } = this.props;
        const classArray = ['video'];
        if (this.props.placeholderText) {
            classArray.push('video--text');
        }
        if (this.state.hideOverview) {
            classArray.push('hide-overview');
        }
        if (position) {
            classArray.push('video--' + position);
        }
        if (!this.context.hasConsent(needsConsent)) {
            classArray.push('video--needs-consent');
        }
        if (className) {
            classArray.push(className);
        }
        if (modifier) {
            classArray.push(modifier);
        }
        return classArray.join(' ');
    }
    renderHtml5(props) {
        const { sources, url, attributes, defaultPlaying } = props;
        const sourceElements = sources ? sources.map((source, key) => (React.createElement("source", Object.assign({}, source, { key: key })))) : null;
        const linkHref = sources ? sources[0].src : url;
        const isHTML5Supported = this.state.isMounted && (typeof (document.createElement('video').canPlayType) !== 'undefined');
        const video = (React.createElement("video", Object.assign({ ref: this.video, preload: "metadata", playsInline: true, controls: true, muted: defaultPlaying ? true : undefined }, attributes, { autoPlay: this.playing, onPause: this.pause, onPlay: this.play, className: "video__html5 lazyload", src: url }), sourceElements));
        return this.renderVideoWrapper(this.BEM('video--html5'), isHTML5Supported ? video : null, linkHref);
    }
    renderIframe(props) {
        const iframe = (React.createElement("iframe", { title: props.title, className: "video__iframe lazyload", "data-src": this.playing ? this.getUrl(props) : undefined, width: "640", height: "360", allowFullScreen: true, onLoad: props.onLoad }));
        return this.renderVideoWrapper(this.BEM(), iframe, props.url);
    }
    renderPosterImage() {
        const { Image } = this.props.components;
        return React.createElement(Image, Object.assign({ className: "video__image" }, this.props.poster));
    }
    renderVideoWrapper(className, children, linkHref) {
        const { Icon } = this.props.components;
        const { needsConsent } = this.props;
        const showOnlyImage = this.props.hideWithoutConsent === 'showPoster' && !this.context.hasConsent(needsConsent);
        const video = (React.createElement(React.Fragment, null,
            React.createElement("a", { href: linkHref, className: "video__btn", target: "_blank", rel: "noopener noreferrer", onClick: this.context.hasConsent(needsConsent) ? this.handleClick : undefined, ref: this.props.elementRef },
                this.renderPosterImage(),
                React.createElement("div", { className: "video__content" },
                    React.createElement("div", { className: "video__icon-wrapper" },
                        React.createElement(Icon, { modifiers: "#play", className: "video__icon" })),
                    this.props.placeholderText && React.createElement("div", { className: "h3 video__placeholder-text" }, this.props.placeholderText))),
            React.createElement("div", { className: "video__holder" }, children)));
        return (React.createElement("figure", { className: className },
            React.createElement("div", { className: "video__inner" }, showOnlyImage ? this.renderPosterImage() : video)));
    }
    render() {
        const { needsConsent, hideWithoutConsent } = this.props;
        if (!this.context.hasConsent(needsConsent) && typeof hideWithoutConsent === 'boolean' && hideWithoutConsent) {
            return null;
        }
        if (this.isHtml5(this.props)) {
            return this.renderHtml5(this.props);
        }
        return this.renderIframe(this.props);
    }
}
VideoCoreInner.defaultProps = {
    needsConsent: ['statistics', 'marketing'],
    implementation: 'iframe',
};
VideoCoreInner.contextType = CookieConsentContext;
export default VideoCore;
